export default {
  data() {
    return {
      chartData: {
        sex: [
          { id: '0', name: '男', value: '11003' },
          { id: '1', name: '女', value: '8997' }
        ],
        age: [
          { id: '0', name: '出生前', value: '234' },
          { id: '1', name: '童年（0-6岁）', value: '1856' },
          { id: '2', name: '少年（7-17岁）', value: '1456' },
          { id: '3', name: '青年（18-40岁）', value: '1521' },
          { id: '4', name: '中年（41-65岁）', value: '6734' },
          { id: '5', name: '老年（66岁以上）', value: '5643' },
          { id: '6', name: '不详', value: '2556' }
        ],
        nation: [
          { id: '0', name: '汉族', value: '18302' },
          { id: '1', name: '少数民族', value: '1698' }
        ],
        nativePlace: [
          { id: '0', name: '北京市', value: '7715' },
          { id: '1', name: '天津市', value: '2521' },
          { id: '2', name: '上海市', value: '1345' },
          { id: '3', name: '重庆市', value: '342' },
          { id: '4', name: '河北省', value: '2516' },
          { id: '5', name: '山西省', value: '1324' },
          { id: '6', name: '辽宁省', value: '678' },
          { id: '7', name: '吉林省', value: '255' },
          { id: '8', name: '黑龙江省', value: '67' },
          { id: '9', name: '江苏省', value: '353' },
          { id: '10', name: '浙江省', value: '256' },
          { id: '11', name: '安徽省', value: '178' },
          { id: '12', name: '福建省', value: '192' },
          { id: '13', name: '江西省', value: '235' },
          { id: '14', name: '山东省', value: '281' },
          { id: '15', name: '河南省', value: '127' },
          { id: '16', name: '湖北省', value: '181' },
          { id: '17', name: '湖南省', value: '162' },
          { id: '18', name: '广东省', value: '192' },
          { id: '19', name: '海南省', value: '25' },
          { id: '20', name: '四川省', value: '256' },
          { id: '21', name: '贵州省', value: '127' },
          { id: '22', name: '云南省', value: '139' },
          { id: '23', name: '陕西省', value: '27' },
          { id: '24', name: '甘肃省', value: '121' },
          { id: '25', name: '青海省', value: '132' },
          { id: '26', name: '台湾省', value: '109' },
          { id: '27', name: '内蒙古自治区', value: '21' },
          { id: '28', name: '广西壮族自治区', value: '45' },
          { id: '29', name: '西藏自治区', value: '23' },
          { id: '30', name: '宁夏回族自治区', value: '34' },
          { id: '31', name: '新疆维吾尔自治区', value: '21' }
        ],
        studyType: [
          { id: '0', name: '临床诊疗', value: '1345' },
          { id: '1', name: '临床试验', value: '1247' },
          { id: '2', name: '队列研究', value: '5865' },
          { id: '3', name: '病例对照研究', value: '1276' },
          { id: '4', name: '抽样调查', value: '1421' },
          { id: '5', name: '普查', value: '7867' },
          { id: '6', name: '不详', value: '79' }
        ],
        sampleType: [
          { id: 0, name: '血液及其分离成分', value: 8913 },
          { id: 1, name: '尿液', value: 2309 },
          { id: 2, name: '指甲和头发', value: 3426 },
          { id: 3, name: '唾液和口腔细胞', value: 1236 },
          { id: 4, name: '母乳', value: 1844 },
          { id: 5, name: '粪便', value: 1237 },
          { id: 6, name: '脑脊液', value: 212 },
          { id: 7, name: '关节腔液', value: 202 },
          { id: 8, name: '石蜡切片', value: 121 },
          { id: 9, name: '其他', value: 500 }
        ],
        health: [
          { id: 0, name: '健康人群', value: 3287 },
          { id: 1, name: '特定疾病人群', value: 16713 }
        ],
        system: [
          { id: 0, name: '运动系统', value: 1254 },
          { id: 1, name: '神经系统', value: 1422 },
          { id: 2, name: '内分泌系统', value: 453 },
          { id: 3, name: '循环系统', value: 546 },
          { id: 4, name: '呼吸系统', value: 627 },
          { id: 5, name: '消化系统', value: 2389 },
          { id: 6, name: '泌尿系统', value: 4271 },
          { id: 7, name: '生殖系统', value: 7654 },
          { id: 8, name: '癌类', value: 562 },
          { id: 9, name: '未知', value: 822 }
        ],
        condition: [
          { id: 0, name: '冰箱', value: 9634 },
          { id: 1, name: '液氮罐', value: 6754 },
          { id: 2, name: '常温', value: 3612 }
        ],
        principle: [
          { id: 0, name: '使用者付费', value: 6754 },
          { id: 1, name: '成果共享', value: 7654 },
          { id: 2, name: '其他', value: 5592 }
        ],
        share: [
          { id: 0, name: '共享样本实体', value: 5672 },
          { id: 1, name: '共享样本信息', value: 5436 },
          { id: 2, name: '共享样本实体及信息', value: 7864 },
          { id: 3, name: '不共享', value: 1028 }
        ]
      }
    }
  }
}
